import { Typography } from "@material-ui/core";
import React, {
  useState,
  useEffect,
  useRef,
} from "react"
import {
  Route,
  useParams,
} from 'react-router-dom';
import { useBookingEvents } from '../hooks/useBookingEvents';
import { getStore } from '../firebase/store';
import UserTable from "./UserTable";
import SlotList from './SlotList';
import BookButton from "./BookButton";

const ListUsersPerTime = () => {
  const [store, setStore] = useState(null);
  const isMounted = useRef(false);
  let { storeId, eventId, slotId } = useParams();
  const events = useBookingEvents(storeId);

  useEffect(() => {
    isMounted.current = true;
    init();
    return (
      () => {
        isMounted.current = false;
      }
    );
  }, []);

  const init = async () => {
    const store = await getStore(storeId);
    isMounted.current && setStore(store);
  };

  return (
    <Route>
      <div style={{ textAlign: "left" }}>
        <Typography
          component="h4"
          variant="h5"
          color="primary"
          style={{ textAlign: "left", marginBottom: 0, fontSize: "2rem" }}
        >
          {
            Object.keys(events).map((key) => {
              const event = events[key];
              if (event.id === eventId) {
                return (
                  <Typography key={event.id} style={{ fontSize: "1.5rem" }}>
                    {"Medlemar som har bokat " + event.dateString}
                  </Typography>
                )
              }
            })
          }
        </Typography>
        <Typography
          component="h2"
          variant="body1"
          color="primary"
          style={{ textAlign: "left", marginBottom: 30 }}
        >
          {store?.name}
        </Typography>

        <SlotList
          events={events}
        />
        <BookButton
          store={store}
          events={events}
        />
        <UserTable
          store={store}
          events={events}
        />
      </div>
    </Route>
  )
}
export default ListUsersPerTime